<script>
import { CONSTANTS } from '../constants.js';
import ItemCard from './ItemCard.vue'
import Histogram from './IPCCard.vue'
import PipeStatusPieChartCard from './PipeStatusPieChartCard.vue';
import HorizontalBarCard from './HorizontalBarCard.vue'
import { barData, horisontalMultiBarData, formatDataPie } from '../dataformatter.js';
import OrderBreakdown from './OrderBreakdown.vue';
import RecutRateTable from './RecutRateTable.vue';

export default {
  name: 'DrillCollarStatistics',
  props: {
    drillCollarData: {
      type: Object,
    },
  },
  components: {
    RecutRateTable,
    ItemCard,
    Histogram,
    PipeStatusPieChartCard,
    HorizontalBarCard,
    OrderBreakdown,
  },
  computed: {
  },
  data() {
    return {
      orderDataTableHeaders: [
        {
          text: 'Item nr',
          value: 'Item_No',
          align: 'start',
        },
        {
          text: 'Order nr',
          align: 'start',
          sortable: true,
          value: 'Order_No'
        },
        {
          text: 'Inspection date',
          sortable: true,
          value: 'Inspection_Date',
          align: "start",
        },
        { text: "Quantity", sortable: true, value: "Quantity", align: "start" },
        { text: "Scrap", sortable: true, value: "Scrap", align: "start" },
        { text: "Recut", sortable: true, value: "Recut", align: "start" },
        { text: "SRF", sortable: true, value: "SRF", align: "start" },
      ],
      machining_card_title: CONSTANTS.MACHINING_CARD_TITLE,
      machining_rates_header: [
        { text: "Connection", value: "connection", align: "start" },
        { text: "OK", value: "ok", align: "start" },
        { text: "Recut", value: "recut", align: "start"},
        { text: "SRF", value: "srf", align: "start" }
      ],
    }
  },
  methods: {
    barData,
    horisontalMultiBarData,
    formatDataPie,
    handleRowClick(row) {
      this.$emit("rowClicked", row)
    }
  }
}
</script>


<template>
  <v-container>
    <!-- 1st row -->
    <v-row class="ma-2">
      <v-col cols="4">
        <v-card class="pa-2 cardWidth" min-height="400px" max-height="400px" dark
          color="#1C355E" elevation="0">
          <ItemCard :itemObject="this.drillCollarData.itemData" />
        </v-card>
      </v-col>
    </v-row>

    <!-- 2nd row -->
    <v-row class="ma-2">
      <v-col cols="4">
        <v-card class="pa-2 cardWidth" min-height="400px" max-height="400px" dark
          color="#1C355E">
          <v-card-title>{{ 'TS Pin' + ' (Min criteria: ' +
            this.drillCollarData.minimum_values.TS_Pin + ')' }}</v-card-title>
          <Histogram
            :IPCData="barData('Tongspace Pin', this.drillCollarData.tongspace.Pin.x, this.drillCollarData.tongspace.Pin.y)"
            :title="'Tongspace Pin'" />
        </v-card>
      </v-col>
      <v-col cols="4">
        <v-card class="pa-2 cardWidth" min-height="400px" max-height="400px" dark
          color="#1C355E">
          <v-card-title>{{ 'TS Box' + ' (Min criteria: ' +
            this.drillCollarData.minimum_values.TS_Box + ')' }}</v-card-title>
          <Histogram
            :IPCData="barData('Tongspace Box', this.drillCollarData.tongspace.Box.x, this.drillCollarData.tongspace.Box.y)"
            :title="'Tongspace Box'" />
        </v-card>
      </v-col>
      <v-col cols="4">
        <v-card class="pa-2 cardWidth" min-height="400px" max-height="400px" dark
          color="#1C355E">
          <v-card-title>{{ 'Box OD' + ' (Min criteria: ' +
            this.drillCollarData.minimum_values.OD_Box + ')'
          }}</v-card-title>
          <Histogram
            :IPCData="barData('OD Box', this.drillCollarData.od.Box.x, this.drillCollarData.od.Box.y)"
            :title="'Box OD'" />
        </v-card>
      </v-col>
    </v-row>

    <!-- 4th row -->
    <v-row class="ma-2">
      <v-col cols="12">
        <v-card class="pa-2 cardWidth" min-height="800px" dark color="#1C355E">
          <v-card-title>{{ this.machining_card_title + " " +
            this.drillCollarData.quantity_inspected + "x inspections excluding scrap"
          }}</v-card-title>
          <HorizontalBarCard
            :barData="horisontalMultiBarData(this.drillCollarData.Machining_Data)"
            :height="'100%'">
          </HorizontalBarCard>
          <v-card-subtitle class="text-start">
            Recut rates
          </v-card-subtitle>
          <RecutRateTable
            :recutData="{ listOfRecutRates: this.drillCollarData.machining_rates, recutRatesTableHeaders: this.machining_rates_header }">
          </RecutRateTable>
        </v-card>
      </v-col>
    </v-row>

    <!-- 5th row -->
    <v-row class="ma-2">
      <v-col cols="12">
        <OrderBreakdown :orderData="{
          listOfOrderData: this.drillCollarData.listOfOrderData,
          orderDataTableHeaders: orderDataTableHeaders
        }" @rowClicked="handleRowClick" :equipmentType="'Drill Collar'">

        </OrderBreakdown>

      </v-col>
    </v-row>
  </v-container>
</template>